// removed by extract-text-webpack-plugin
module.exports = {"Sal":"_2RK5nNOOkNs9j1U1ocYi7R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExhibitionMap/Sal.module.css
// module id = 97
// module chunks = 8